import PanicButtonContainer from './components/panic_button_container';

export default PanicButtonContainer;
